<template>
  <svg width="17" height="17" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path
        d="M12.232 8.795h2.032V6.763h-2.032v2.032zm0 3.186h2.032V9.949h-2.032v2.032zm0 3.184h2.032v-2.032h-2.032v2.032zm0 3.185h2.032v-2.032h-2.032v2.032zM9.134 8.795h2.032V6.763H9.134v2.032zm0 3.186h2.032V9.949H9.134v2.032zm0 3.184h2.032v-2.032H9.134v2.032zm0 3.185h2.032v-2.032H9.134v2.032zM6.037 8.795h2.032V6.763H6.037v2.032zm0 3.186h2.032V9.949H6.037v2.032zm0 3.184h2.032v-2.032H6.037v2.032zm0 3.185h2.032v-2.032H6.037v2.032zm13.586-7.862H16.45c-.054 0-.103.017-.152.031V4.57a.572.572 0 0 0-.57-.57H4.57a.572.572 0 0 0-.57.57v15.688c0 .314.257.57.57.57H15.73a.56.56 0 0 0 .361-.139c.1.084.223.14.36.14h3.173c.313 0 .57-.257.57-.571v-9.2a.572.572 0 0 0-.57-.57z"
        fill="currentColor" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Building',
};
</script>
